export default {
    siteName: 'VR实验室',
    siteShort: 'VR Lab',
  };
